import { JobRecuruitPrImageResponse } from '@doda/api-client/aspida/@types';
import { Button } from '@doda/io-react/common';
import { TAB_JOBDETAIL } from '@doda/common/src/constants/properties/const';
import { useGetPickupContents } from '@doda/common/src/hooks/jobSearchDetail/useGetPickupContents';
import styles from './index.module.scss';
import { useTab } from '../../TabArea/hooks/useTab';
import { Tab } from '../../../types/tab';
import { PromoteApplicationModalDisplayTarget } from '../../PromoteApplicationModal';

/**
 * Pickupのprops
 */
export interface PickupProps {
  /** pickupで使用する画像やHTMLを含む */
  recruitPrImage: JobRecuruitPrImageResponse | undefined;
  /** pr画像のaltテキスト */
  altText: string;
  /** 求人ID */
  jid: string;
  /** 初期表示時のタブ */
  initialTab: Tab;
  /** 原稿種別 */
  wcnsId: string;
  /** 応募済みか */
  isApplied: boolean;
  /** スカウト求人か */
  isScout: boolean;
  /** 閲覧済みか */
  isRead: boolean;
}

/**
 * E原稿 pickupタブ
 */
export const Pickup: React.FC<PickupProps> = ({
  recruitPrImage,
  altText,
  initialTab,
  jid,
  wcnsId,
  isApplied,
  isScout,
  isRead,
}: PickupProps) => {
  const { onChangeTab } = useTab({ initialTab, jid, wcnsId });
  const { mapTags, usemapNameList } = useGetPickupContents({ recruitPrImage });
  const imageList = recruitPrImage?.imagePathList || null;

  return (
    <>
      <div className={styles['jobSearchDetail-pickup__content']}>
        <div>
          {recruitPrImage?.imagePathList &&
            recruitPrImage.imagePathList.length >= 1 && (
              <h1
                className={styles['jobSearchDetail-pickup__imageContainer']}
                style={{
                  minHeight: imageList && imageList.length > 0 ? 300 : 0,
                }}
              >
                {imageList?.map((imagePath, i) => (
                  <img
                    src={imagePath}
                    alt={altText}
                    useMap={usemapNameList[i]}
                    className={styles['jobSearchDetail-pickup__image']}
                    key={imagePath}
                  />
                ))}
              </h1>
            )}
          {mapTags && (
            <div
              // eslint-disable-next-line react/no-danger
              dangerouslySetInnerHTML={{
                __html: mapTags,
              }}
            />
          )}
        </div>
        {/* 詳細（details） */}
        <div className={styles['jobSearchDetail-pickup__detailButton']}>
          <PromoteApplicationModalDisplayTarget {...{ isScout, isRead }}>
            <Button
              variant="green"
              size="L"
              onClick={() => onChangeTab(TAB_JOBDETAIL, isApplied)}
            >
              この求人の募集要項へ
            </Button>
          </PromoteApplicationModalDisplayTarget>
        </div>
      </div>
      {/* 共通フッターコンテンツ */}
    </>
  );
};
